import calls from '@/backend/api-calls'

const state = () => ({
  services: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
  }
})

// getters
const getters = {
  ids: state => {
    return state.services.map(d => d.id);
  }
}

// actions
const actions = {
  getServices: ({commit}, parameters) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      calls.services.get(parameters)
        .then(resp => {
          commit("setServices", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addService: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.services.post(data)
        .then(resp => {
          commit("insertService", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Service successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateService: ({commit}, { serviceId, data }) => {
    return new Promise((resolve, reject) => {
      calls.service.put(serviceId, data)
        .then(resp => {
          commit("insertUpdatedService", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Service successfully updated'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteService: ({commit}, serviceId) => {
    return new Promise((resolve, reject) => {
      calls.service.delete(serviceId)
        .then(resp => {
          commit("removeService", serviceId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Service successfully deleted'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setServices (state, data) {
    state.services = data.results;
    state.pagination = data.pagination;
  },
  insertService (state, data) {
    state.services.push(data);
  },
  insertUpdatedService (state, data) {
    state.services.forEach((service, i) => {
      if (service.id == data.id) {
        state.services.splice(i, 1, data);
      }
    })
  },
  removeService (state, id) {
    state.services.forEach((service, i) => {
      if (service.id == id) {
        state.services.splice(i, 1);
        let ind = state.selected.indexOf(id);
        if (ind != -1) {
          state.selected.splice(ind);
        }
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}